export { default } from './Professional';
export { default as datamap } from './Professional.datamap';
export type { PageData } from './Professional.datamap';
